<ion-toolbar
  *ngIf="showDefinitionBar"
  class="crossword-definition-toolbar"
  color="white"
  [class.remove-side-margins]="framework.puzzleFrameworkConfig.removeSideMargins"
>
  <div class="crossword-definition-toolbar-inner">
    <ion-buttons slot="start">
      <ion-button (click)="onDefinitionBarPrevClicked($event)" class="definition-button" color="primary" size="small">
        <ion-icon class="prev-definition-icon" name="chevron-back-sharp" size="small" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title *ngIf="currentWord && currentWord.definTextLong" class="ion-text-center definition-title">
      <div class="ion-text-wrap">{{currentWord.definTextLong}}</div>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="onDefinitionBarNextClicked($event)" class="definition-button" color="primary" size="small">
        <ion-icon class="next-definition-icon" name="chevron-forward-sharp" size="small" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </div>
</ion-toolbar>
